<template>
	<div>
    <div class="container is-max-desktop p-5">
      <LoginHeader/>
      <div class="columns">
          <div class="column">
            <div class="content has-text-left">
              <!-- Text gelecek -->
              <h3 v-html="$t('meet_iys_panel')"></h3>
              <ul>
                <li v-html="$t('end-to-end_IYS_integration')"></li>
                <li v-html="$t('user-friendly_interface')"></li>
                <li v-html="$t('compherensive_modules_for_brand_and_retail_management')"></li>
                <li v-html="$t('easy_reporting')"></li>
                <li v-html="$t('fully_automatic_consent_management')"></li>
                <li v-html="$t('advanced_solutions_with_the_use_of_IYS_API')"></li>
              </ul>
              <router-link to="/login" custom v-slot="{ navigate }">
                <a type="is-primary" outlined @click="navigate" role="link">
                  <span class="mdi mdi-arrow-left"></span>
                  {{$t('back')}}
                  </a>
              </router-link>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <p class="card-header-title pl-5">
                {{$t('consult_our_experts')}}
              </p>
              <p class="pl-5">
                {{$t('fill_out_the_form')}}
              </p>
              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                <div class="card-content has-text-left">

                   <ValidationProvider rules="requiredNameSurname" v-slot="{ errors }">
                      <b-field :label="labels.nameSurname.show?$t('nameSurname'):''" :label-position="labels.nameSurname.position" class="mb-5"
                        :type="{'is-danger':errors[0]}"
                        :message="[$t(errors[0])]">
                          <b-input type="text" :placeholder="$t('nameSurname')+'*'" @keyup.enter.native="handleSubmit(recaptcha)" v-model.trim="loginForm.nameSurname" @focus="focusInput('nameSurname')" @blur="blurInput('nameSurname')"></b-input>                  
                      </b-field>
                  </ValidationProvider>

                   <ValidationProvider rules="requiredEmail|validEmail" v-slot="{ errors }">
                      <b-field :label="labels.email.show?$t('email'):''" :label-position="labels.email.position" class="mb-5"
                        :type="{'is-danger':errors[0]}"
                        :message="[$t(errors[0])]">
                          <b-input :placeholder="$t('email')+'*'" @keyup.enter.native="handleSubmit(recaptcha)" v-model.trim="loginForm.email" @focus="focusInput('email')" @blur="blurInput('email')"></b-input>                  
                      </b-field>
                  </ValidationProvider>

                  <ValidationProvider rules="requiredPhone" v-slot="{ errors }">
                      <b-field :label="labels.phone.show?$t('phone'):''" :label-position="labels.phone.position" class="mb-5"
                        :type="{'is-danger':errors[0]}"
                        :message="[$t(errors[0])]">
                          <b-input type="tel" :placeholder="$t('phone')+'*'" @keyup.enter.native="handleSubmit(recaptcha)" v-model.trim="loginForm.phone" @focus="focusInput('phone')" @blur="blurInput('phone')"></b-input>                  
                      </b-field>
                  </ValidationProvider>

                  <ValidationProvider>
                      <b-field :label="labels.message.show?$t('message'):''" :label-position="labels.message.position" class="mb-5">
                          <b-input type="textarea" @keyup.enter.native="handleSubmit(recaptcha)" :placeholder="$t('message')" v-model="loginForm.message" @focus="focusInput('message')" @blur="blurInput('message')"></b-input>
                      </b-field>
                  </ValidationProvider>

                  
                  
                  <div class="columns">
                    <div class="column is-flex is-align-items-center is-justify-content-space-between">
                      <!-- <b-button type="is-primary" @click="handleSubmit(loginF)">{{$t('send')}}</b-button> -->

                      <b-button type="is-primary" @click="handleSubmit(recaptcha)" role="link">{{$t('send')}}</b-button>
                    
                      <!-- <router-link to="/forgotPassword" custom v-slot="{ navigate }">
                        <a @click="navigate" role="link">{{$t('forgot_password')}}</a>
                      </router-link> -->
                    </div>
                  </div>  
                </div>
              </ValidationObserver>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {mapActions} from 'vuex'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
// import { VueReCaptcha } from "vue-recaptcha-v3";
import VueRecaptcha from 'vue-recaptcha';
Vue.use(VueRecaptcha, { siteKey: "6LeYKqEaAAAAACGtD789bVqEDcHrzh1a0VJtPgCK" });
import { required, email } from 'vee-validate/dist/rules';
import LoginHeader from './LoginHeader';

extend('requiredNameSurname', {
  ...required,
  message: 'nameSurname_is_required'
});

extend('requiredEmail', {
  ...required,
  message: 'email_is_required'
});

extend('validEmail',{
  ...email,
  message : 'please_enter_a_valid_email'
});

extend('requiredPhone', {
  ...required,
  message: 'phone_is_required'
});

export default {
  name: 'Login',
  components: {
    LoginHeader,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      
      loginForm:{
        nameSurname: '',
        email:'',
        phone: '',
        message:''
      },
      labels:{
        nameSurname:{position:'',show:false},
        email:{position:'',show:false},
        phone:{position:'',show:false},
        message:{position:'',show:false}
      }
    }
  },
  methods: {
    ...mapActions(['getConsultOurExperts']),
    focusInput(val){
      this.labels[val].position='on-border'
      this.labels[val].show=true
    },
    blurInput(val){
      if(this.loginForm[val]==''){
        this.labels[val].show=false
      }
    },
     async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()
      
 
      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha().then(function(token){
        console.log('------ recaptha tokenı ---------')
        console.log(token)
      })
 
      // Do stuff with the received token.
      this.loginForm['g-recaptcha-response'] = token
      console.log(token)

      this.sendingForm()

    // console.log('recaptcha clicked')
    //   this.$recaptchaLoaded().then(() => {
    //     console.log('recaptcha loaded')
    //     this.$recaptcha('login').then((token) => {
    //       console.log(token) // Will print the token
    //     })
    //   })

    },
    sendingForm(){
      this.getConsultOurExperts(this.loginForm).then((response) => {
          console.log('--getConsultOurExperts success response')
          console.log(response)
          if(response.status.code == '0'){
            this.$moment.locale(response.content.language)
            this.$i18n.locale = response.content.language
            this.$router.push('/')
          }
      }).catch(e => {
          console.log('--getConsultOurExperts Error')
          console.log(e)
      })
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ConsultOurExperts.vue